// eslint-disable
// this is an auto generated file. This will be overwritten

export const createCanvas = `mutation CreateCanvas($input: CreateCanvasInput!) {
  createCanvas(input: $input) {
    id
    clientId
    data
  }
}
`;
export const updateCanvas = `mutation UpdateCanvas($input: UpdateCanvasInput!) {
  updateCanvas(input: $input) {
    id
    clientId
    data
  }
}
`;
export const deleteCanvas = `mutation DeleteCanvas($input: DeleteCanvasInput!) {
  deleteCanvas(input: $input) {
    id
    clientId
    data
  }
}
`;
